import { Button, MinthrSelect, Sidebar, TextArea } from 'components/common';
import { useSidebarManager } from 'contexts/SidebarManagerContext';
import { GetPayBy } from 'features/expenses/services/Expenses';
import { Formik, Form } from 'formik';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface ExpensesRefundProps {
  noteId: number;
  handleStatusChange: (
    status: number,
    refundedBy?: string,
    comment?: string,
  ) => void;
  toggleRefresh: () => void;
  toggleRefreshDT?: () => void;
}
const ExpensesRefund: FC<SideBarProps<ExpensesRefundProps>> = ({
  sidebar,
  setSidebarWidth,
  sidebarWidth,
  params,
}) => {
  const { t } = useTranslation();
  const { closeSidebar } = useSidebarManager();
  const [payementTypes, setPayementTypes] = useState<SelectItem[]>([]);

  useEffect(() => {
    GetPayBy().then((res) => {
      setPayementTypes(res.data);
    });
  }, []);

  return (
    <Sidebar
      size="m"
      type="secondary"
      sidebar={sidebar}
      setSidebarWidth={setSidebarWidth}
      sidebarWidth={sidebarWidth}
    >
      <div id="cancel_modal" className="minthr-h-100">
        <div className="minthr-flex minthr-flex-items-center minthr-pb-2 minthr-mb-3 minthr-border-b minthr-border-b-3">
          <div className="minthr-icon-bg minthr-icon-bg-l minthr-icon-bg-secondary minthr-icon-circle minthr-mr-3">
            <img className="minthr-icon-m" src="/icons/wallet.svg" alt="" />
          </div>
          <h3>{t('expenses.refund.model.title')}</h3>
          <button
            className="minthr-sidebar-close"
            type="button"
            onClick={() => {
              closeSidebar(ExpensesRefund);
            }}
          >
            <img src="/icons/close.svg" alt="" />
          </button>
        </div>
        <Formik
          initialValues={{
            refundedBy: '',
            comment: '',
          }}
          onSubmit={(values) => {
            params.handleStatusChange(3, values.refundedBy, values.comment);
            params.toggleRefresh();
            params?.toggleRefreshDT?.();
            closeSidebar(ExpensesRefund);
          }}
        >
          {({ values, isSubmitting }) => (
            <Form className="w-100">
              <div className="row g-0 minthr-mb-5">
                <div className="col-sm-12">
                  <MinthrSelect
                    options={payementTypes.map((item) => ({
                      label: item.text,
                      value: item.value,
                    }))}
                    name="refundedBy"
                    label={t('Expense.PayedBy')}
                    className="minthr-form-outline"
                    value={
                      payementTypes.find(
                        (item) => item.value === values.refundedBy,
                      )?.value || ''
                    }
                  />
                </div>
              </div>
              <div className="row g-0 minthr-mb-5">
                <div className="col-sm-12">
                  <TextArea label={t('comment')} name="comment" />
                </div>
              </div>
              <div className="minthr-sidebar-footer minthr-box-shadow minthr-flex minthr-flex-items-center minthr-flex-items-end minthr-py-4 minthr-mx-n5 minthr-px-6 minthr-mt-auto">
                <button
                  type="button"
                  className="minthr-btn minthr-btn-outline minthr-btn-primary minthr-ml-auto minthr-sidebar-close"
                >
                  {t('cancel')}
                </button>
                <Button
                  type="submit"
                  loading={isSubmitting}
                  className="minthr-btn minthr-btn-primary minthr-ml-6 detail-depense-sidebar-open"
                >
                  {t('submit')}
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Sidebar>
  );
};

export default ExpensesRefund;
